import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./App.css";

// import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from "@mui/material/styles";

let theme = createTheme({
  typography: {
    

    h1: {
      fontFamily: "Inter900",
      fontSize:"62px !important",
      lineHeight:"72px !important"
    },
    
    h2: {
      fontFamily: "Inter400",
      fontSize:"42px !important",
      lineHeight:"42px !important"
    },
    
  
    // button1: {
    //   backgroundColor: "red !important",
    //   fontWeight: 'bold',
    // },
    // button2: {
      // fontFamily: "Inter500",
      // fontSize:"18px !important",
      // background: #E90707 !important;
      // padding: 8px 24px 8px 24px !important;
      // borderRad: "27px !important";
    // },
  },
  // buttonStyle: {
  //   primary: {
  //     main: purple[500],
  //   },
  //   secondary: {
  //     main: green[500],
  //   },
  // }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
